import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestScannerResultTemplatesGet = {
    path: "/scanner/result/templates",
    method: RouteHttpVerb.GET
};
export { locationRestScannerResultTemplatesGet };
